export enum SmoSocketServerEvent {
  widget_connected = 'widget_connected',
  settings_updated = 'settings_updated',
  environment_updated = 'environment_updated',
  run_updated = 'run_updated'
}
